import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet'
import axios from 'axios';
import './styles/App.css';
import ModelDetail from "./ModelDetail.jsx";
import Subscription from "./Subscription.jsx";
var Spinner = require('react-spinkit');

class Framework extends Component {
  constructor(props) {
    super(props);
    this.state = {
      models: [],
      filtered_models: [],
      filter: "",
      loaded: false,
    }

    this.filterModels = this.filterModels.bind(this);
    this.filterChanged = this.filterChanged.bind(this);
    this.loadData = this.loadData.bind(this);
  }

  componentDidMount() {
    this.loadData();
  }

  componentWillReceiveProps(nextProps) {
    this.loadData();
  }

  loadData() {
    axios.all([
      axios.get(process.env.REACT_APP_API + '/api/frameworks/' + this.props.match.params.slug + '/50/')
    ])
    .then(axios.spread((models_response) => {
      this.setState({models: models_response.data.models, loaded: true});

      // Load full list
      axios.all([
        axios.get(process.env.REACT_APP_API + '/api/frameworks/' + this.props.match.params.slug + '/0/')
      ])
      .then(axios.spread((full_models_response) => {
        this.setState({models: full_models_response.data.models});
        this.filterModels(this.state.filter);
      }));
    }));
  }

  filterModels(filter) {
    if(this.state.models) {
      const filtered_models = this.state.models.filter(model =>
        model.title.toUpperCase().includes(filter.toUpperCase()) ||
        (model.description && model.description.toUpperCase().includes(filter.toUpperCase())) ||
        this.props.frameworks[model.framework].title.toUpperCase().includes(filter.toUpperCase()));
      this.setState({ filtered_models: filtered_models });
    }
  }

  filterChanged(event) {
    const filter = event.target.value;
    this.setState({ filter: filter });
    this.filterModels(filter);
  }

  render() {
    const NoMatch = (
      <div>
        <Helmet>
          <title>Model Zoo - Page not found!</title>
        </Helmet>
        <h1>Whoops!</h1>
        <p>You must have taken a wrong turn! Follow our navbar (above) to get back somewhere safe.</p>
      </div>
    );

    const framework = this.props.frameworks[this.props.match.params.slug.toLowerCase()];

    const searchForm = <div className="input-group">
      <div class="input-group-prepend">
        <span class="input-group-text" id="basic-addon1"><i class="fas fa-search"></i></span>
      </div>
      <input name="filter" placeholder="Filter models..." type="text" className="form-control" value={this.state.filter} onChange={this.filterChanged} /></div>;
    const models = this.state.filtered_models && framework ? (this.state.filtered_models.map((model) =>
          <ModelDetail key={model.slug} framework={this.props.frameworks[model.framework]} model={model}/>
        )) : "";
    const modelDisplay = []

    for(var i = 0; i < models.length; i ++) {
      modelDisplay.push(models[i]);

      if(i == 3) {
        modelDisplay.push(<div className="email-div-home col-md-4 d-flex align-items-stretch"><Subscription /></div>);
      }
    }

    return this.props.frameworks && !framework ? NoMatch : (
      <div>
      <Helmet>
        <title>Model Zoo - {framework.title} Deep Learning Code and Models</title>
        <meta name="description" content={framework.description} />
      </Helmet>

      <h1>{framework.title}</h1>
      <div className="" dangerouslySetInnerHTML={{__html: framework.description}}></div>
      <Link to={framework.link} target="_blank">More Info</Link>
      <hr/>
      <div>
      {searchForm}
      <br/>
      <div className="row">
      { this.state.loaded ? "" : <Spinner name="three-bounce" fadeIn="none" /> }
      {modelDisplay}
      </div>
      </div>
      </div>
    );
  }
}

export default Framework;


// WEBPACK FOOTER //
// ./src/Framework.jsx